export const AI_ASSISTANT = 'ai-assistant';
export const ANALYZE = 'analyze';
export const CREATE = 'create';
export const DETAILS = 'details';
export const GOALS = 'goals';
export const HEALTH = 'health';
export const PARAMETERIZED_TEMPLATE_SELECT = 'parameterized-template-select';
export const PARAMETERIZED_TEMPLATE_WIZARD = 'parameterized-template-wizard';
export const PERFORMANCE = 'performance';
export const PLATFORM_CREATE = 'platform-create';
export const PLATFORM_FLOW = 'platform-flow';
export const PLATFORM_FLOW_DATA_SOURCE_EDIT_CONTAINER = 'platform-flow-data-source-edit-container';
export const PLATFORM_FLOW_GO_TO_EDIT_CONTAINER = 'platform-flow-go-to-edit-container';
export const PLATFORM_FLOW_OPTIMIZATION_CONTAINER = 'platform-flow-optimization-container';
export const PLATFORM_FLOW_MOVE_ACTION_CONTAINER = 'platform-flow-move-action-container';
export const PLATFORM_FLOW_REVISION_PREVIEW_CONTAINER = 'platform-flow-revision-preview-container';
export const PLATFORM_HISTORY = 'platform-history';
export const PLATFORM_INDEX = 'platform-index';
export const PLATFORM_RESTORE_WORKFLOWS = 'platform-restore-workflows';
export const PLATFORM_REVIEW = 'platform-review';
export const PLATFORM_SETTINGS = 'platform-settings';
export const PLATFORM_FLOW_CHANGES = 'platform-flow-changes';
export const TEMPLATE_LIBRARY = 'template-library';
export const TEMPLATE_LIBRARY_INDIVIDUAL_TEMPLATE_PREVIEW = 'template-library-individual-template-preview';